import { Box, Flex } from '@chakra-ui/react';
import logo from '../../../utils/assets/img/logo.png';

export function SidebarBrand(props: { isCollapsed?: boolean }) {
	const { isCollapsed } = props;
	return (
		<Flex alignItems='center' flexDirection='column'>
			<Box h='36px' w={isCollapsed ? '36px' : '195px'} my='10px' mb='20px' mr='0px' ml={isCollapsed ? '0px' : '20px'}>
				{!isCollapsed && (
					<img src={logo} alt="Brand Logo" height="26px" width="146px" style={{ margin: '30px 0' }} />
				)}
			</Box>
		</Flex>
	);
}

export default SidebarBrand;
